//localStorage封装
var storage = {
    set(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    },
    get(key) {
        return JSON.parse(localStorage.getItem(key));
    },
    clear() {
        localStorage.clear();
    },
    del(key){
        localStorage.removeItem(key)
	}
}
export default storage;


// WEBPACK FOOTER //
// ./src/storage/storage.js